import React from 'react'

const RateContext = React.createContext({
  items: [],
  addRate: () => {},
  removeRate: () => {},
})

export default RateContext
